<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="isOpen"
        class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 transition-opacity duration-200"
        @click.self="cancel"
      >
        <div
          class="w-full max-w-md transform rounded-lg border border-slate-200 bg-white shadow-xl transition-all duration-200"
        >
          <!-- Header -->
          <div class="border-b border-slate-200 px-6 py-4">
            <div class="flex items-center gap-3">
              <div
                class="flex h-10 w-10 items-center justify-center rounded-full bg-red-100"
              >
                <i class="pi pi-exclamation-triangle text-lg text-red-600"></i>
              </div>
              <p class="text-xl mb-0 font-bold text-slate-900">{{ title }}</p>
            </div>
          </div>

          <!-- Body -->
          <div class="px-6 py-4">
            <p class="text-slate-600">{{ message }}</p>
          </div>

          <!-- Footer -->
          <div
            class="flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
          >
            <button
              @click="cancel"
              class="inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="isLoading"
            >
              <span>Huỷ</span>
            </button>
            <button
              @click="confirm"
              class="inline-flex items-center justify-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="isLoading"
            >
              <i v-if="isLoading" class="pi pi-spin pi-spinner"></i>
              <i v-else class="pi pi-trash"></i>
              <span>{{ isLoading ? "Đang xoá..." : "Xoá" }}</span>
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";

export default defineComponent({
  name: "ConfirmDeleteModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Xác nhận xoá",
    },
    message: {
      type: String,
      default: "Bạn có chắc chắn muốn xoá mục này?",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const confirm = () => {
      emit("confirm");
    };

    const cancel = () => {
      isOpen.value = false;
      emit("cancel");
    };

    return {
      isOpen,
      confirm,
      cancel,
    };
  },
});
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-to,
.modal-leave-from {
  opacity: 1;
}
</style>
